"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkingPresetNameSchema = exports.CHUNKING_PRESETS = exports.ChunkingMethod = exports.ChunkingProvider = exports.ChunkingPresetName = void 0;
exports.isChunkingPresetName = isChunkingPresetName;
exports.getChunkingPreset = getChunkingPreset;
const zod_1 = require("zod");
var ChunkingPresetName;
(function (ChunkingPresetName) {
    ChunkingPresetName["LCRecursiveSize1000Overlap200"] = "LCRecursiveSize1000Overlap200";
})(ChunkingPresetName || (exports.ChunkingPresetName = ChunkingPresetName = {}));
var ChunkingProvider;
(function (ChunkingProvider) {
    ChunkingProvider["LangChain"] = "LangChain";
})(ChunkingProvider || (exports.ChunkingProvider = ChunkingProvider = {}));
var ChunkingMethod;
(function (ChunkingMethod) {
    ChunkingMethod["RecursiveCharacterTextSplitter"] = "RecursiveCharacterTextSplitter";
})(ChunkingMethod || (exports.ChunkingMethod = ChunkingMethod = {}));
exports.CHUNKING_PRESETS = {
    [ChunkingPresetName.LCRecursiveSize1000Overlap200]: {
        displayName: 'LangChain Recursive - Size 1000 Overlap 200',
        provider: ChunkingProvider.LangChain,
        method: ChunkingMethod.RecursiveCharacterTextSplitter,
        chunkSize: 1000,
        chunkOverlap: 200,
        providerOptions: {
            separators: ['\n## ', '\n### ', '\n#### ', '\n\n', '\n', ' '],
        },
    },
};
exports.ChunkingPresetNameSchema = zod_1.z.nativeEnum(ChunkingPresetName);
function isChunkingPresetName(name) {
    return Object.values(ChunkingPresetName).includes(name);
}
function getChunkingPreset(name) {
    return exports.CHUNKING_PRESETS[name];
}
//# sourceMappingURL=chunking-presets.js.map